export const en = {
    moscow: 'Moscow',
    'phone-extension': 'ext. {phone}',
    regions: 'Regions'
};
